import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function WhyItHappens() {
  return <Section alt data-id="element-167">
      <FadeIn data-id="element-168">
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-6" data-id="element-169">
          No te falta amor. Te falta espacio.
        </h2>
        <div className="space-y-4 text-lg text-gray leading-relaxed" data-id="element-170">
          <p data-id="element-171">
            Hay un cansancio que no se quita durmiendo: el de estar todo el día
            en alerta. Ruido, demandas, decisiones, logística… y encima intentar
            hacerlo con buena cara.
          </p>
          <p data-id="element-172">
            Cuando tu sistema nervioso se satura, baja la paciencia y sube la
            culpa. No es un defecto tuyo: es una señal.
          </p>
        </div>
      </FadeIn>
    </Section>;
}